module.exports = __webpack_public_path__ + "img/apple.9a033db2.svg";